import { render, staticRenderFns } from "./redirectToHome.vue?vue&type=template&id=1665b73a&"
import script from "./redirectToHome.vue?vue&type=script&lang=js&"
export * from "./redirectToHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports